import { Nullable } from "@/api/ApiClient";
import { WithReferenceCode } from "./ReferenceCodeType";

export type CreditnoteFormData = WithReferenceCode<Nullable<{
    id: string,
    numero: number,
    sequence: string,
    document_key: string,
    need_assignment: boolean,
    description: string,
    email: string,
    subtotal: number,
    discountCode: string,
    descuento: number,
    impuestos: number,
    impuestos_servicio: number,
    total: number,
    exchange_rate: number,
    edocument_status: number,
    edocument_status_payload: string,
    created: string,
    activitycode: string,
    selected_logo: number,
    excludeFromReport: boolean,
    price_note: boolean,
    anulada: boolean,
    info_references: string,
    otros_cargos: string,
    pending_submission: string,
    pending_submission_attempts: number,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    invoiceId: string,
    invoice: any,
    buyInvoiceId: string,
    appliedInvoiceId: string,
    appliedInvoice: any,
    creditnoteProducts: any[],
    user: string,
}>>

export const CreditnoteRelatedAttributes: Array<keyof CreditnoteFormData> = ["client", "currency", "invoice", "appliedInvoice", "creditnoteProducts"];